/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Feedback_Question_P1Inputs */

const en_ai_feedback_question_p1 = /** @type {(inputs: Ai_Feedback_Question_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to receive general feedback on your resume (e.g., structure, completeness, etc.) from an AI?`)
};

const de_ai_feedback_question_p1 = /** @type {(inputs: Ai_Feedback_Question_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchtest du von einer KI allgemeines Feedback zu deinem Lebenslauf (z. B. Aufbau, Vollständigkeit etc.) erhalten?`)
};

/**
* | output |
* | --- |
* | "Would you like to receive general feedback on your resume (e.g., structure, completeness, etc.) from an AI?" |
*
* @param {Ai_Feedback_Question_P1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_feedback_question_p1 = /** @type {((inputs?: Ai_Feedback_Question_P1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Feedback_Question_P1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_feedback_question_p1(inputs)
	return en_ai_feedback_question_p1(inputs)
});